import React, { useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import { Box, Typography } from "@mui/material";
import { PREP_CAL_COLORS } from "./prepCalendarEvents";

// Categories in legend order. Each is shown only if the events include it, and
// clicking one hides/shows that category on the grid.
const CATEGORIES = [
    { key: "exam", label: "Exams", color: PREP_CAL_COLORS.exam },
    { key: "homework", label: "Homework", color: PREP_CAL_COLORS.homework },
    { key: "done", label: "Completed", color: PREP_CAL_COLORS.done },
];

// Month-grid view of prep events (exams + homework), shared by the editor's
// Calendar tab and the dashboard's per-student calendar. The legend doubles as a
// per-category show/hide filter. Read-only.
const PrepCalendar = ({ events, initialDate }) => {
    const [hidden, setHidden] = useState(() => new Set());

    const present = new Set(events.map((e) => e.extendedProps?.category));
    const toggle = (key) =>
        setHidden((prev) => {
            const next = new Set(prev);
            if (next.has(key)) next.delete(key);
            else next.add(key);
            return next;
        });

    const shown = events.filter((e) => !hidden.has(e.extendedProps?.category));

    return (
        <Box>
            <Box sx={{ display: "flex", gap: 2, mb: 1.5, flexWrap: "wrap", alignItems: "center" }}>
                {CATEGORIES.filter((c) => present.has(c.key)).map((c) => {
                    const off = hidden.has(c.key);
                    return (
                        <Box
                            key={c.key}
                            onClick={() => toggle(c.key)}
                            sx={{
                                display: "flex", alignItems: "center", gap: 0.5,
                                cursor: "pointer", userSelect: "none", opacity: off ? 0.4 : 1,
                            }}
                        >
                            <Box sx={{ width: 12, height: 12, borderRadius: "2px", bgcolor: c.color }} />
                            <Typography variant="caption" color="text.secondary"
                                sx={{ textDecoration: off ? "line-through" : "none" }}>
                                {c.label}
                            </Typography>
                        </Box>
                    );
                })}
                <Typography variant="caption" color="text.secondary">
                    ▶ release · ⏹ due — click a label to show/hide
                </Typography>
            </Box>
            <Box sx={{ "& .fc": { fontSize: 13 }, "& .fc .fc-toolbar-title": { fontSize: "1.05rem" } }}>
                <FullCalendar
                    plugins={[dayGridPlugin]}
                    initialView="dayGridMonth"
                    initialDate={initialDate || undefined}
                    headerToolbar={{ left: "prev,next today", center: "title", right: "" }}
                    events={shown}
                    height="auto"
                    displayEventTime={false}
                    eventDisplay="block"
                    dayMaxEvents={4}
                />
            </Box>
        </Box>
    );
};

export default PrepCalendar;
